import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-advanced-image';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo advanced-image');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        this.timeline = new TimelineMax();
        this.controller = new ScrollMagic.Controller();
        
        // Tasks on images
        if(!isMobile.check()) {
            setTimeout(() => { this.task1() },0); // prima l'immagine centrale
        }
    }
    
    /**
     * Appare l'immagine
     * @returns {undefined}
     */
    task1() {
        // Image 1
        let $target = this.$module.querySelector('.image1 > .image');

        if (!$target) return;

        var tweenCaption = this.timeline
            .to($target, 2, {opacity: 1, ease: Sine.easeOut })

        new ScrollMagic.Scene({
            triggerElement: this.$module,
            triggerHook:.8, // lo pinna quando è in alto (a 0)
            duration: "70%", // e lo tiene pinnato per la duration
            offset: 50
        })
        .setTween(tweenCaption)
        // .addIndicators({name: "Pattern1.1"}) // add indicators (requires plugin)
        .addTo(this.controller);
    }

    // _________________________________________________________________________

    getTranslateX(el) {
        var style = window.getComputedStyle(el);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);
        return matrix.m41;
    }

    // _________________________________________________________________________

    getTranslateY(el) {
        var style = window.getComputedStyle(el);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);

        return matrix.m41;
    }
    
    // _________________________________________________________________________
    
    getTranslate(item) {
        var transArr = [];

        if (!window.getComputedStyle) return;
        var style     = getComputedStyle(item),
            transform = style.transform || style.webkitTransform || style.mozTransform || style.msTransform;
        var mat       = transform.match(/^matrix3d\((.+)\)$/);
        if (mat) return parseFloat(mat[1].split(', ')[13]);

        mat = transform.match(/^matrix\((.+)\)$/);
        mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
        mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);
        
        transArr.x = transArr[0];
        transArr.y = transArr[1];

        return transArr;
    }

    // _________________________________________________________________________
    
    /**
     * Return current screen size
     * @returns {Int}
     */
    get_current_resolution() {
        return 'screen' in window && window.screen.width;
    }

    // _________________________________________________________________________
    
    /**
     * Return current window size
     * @returns {Int}
     */
    get_current_innerwidth() {
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight|| e.clientHeight|| g.clientHeight;
    
        return x; 
    }
}

// export
export default new Module();